import request from '@/config/axios'

// 价格模板 VO
export interface PriceTemplateVO {
  id: string | number
  shopId: string | number
  spuId: string | number
  templateName: string
  priceType: number
  priceValue: number
  applicableDays: string
  startDate: string
  endDate: string
  status: number
  createTime: Date
}

// 获取价格模板分页
export function getPriceTemplatePage(params: any) {
  return request.get({ url: '/hotel/price-template/page', params })
}

// 获取价格模板详情
export function getPriceTemplate(id: string | number) {
  return request.get({ url: '/hotel/price-template/get?id=' + id })
}

// 创建价格模板
export function createPriceTemplate(data: PriceTemplateVO) {
  return request.post({ url: '/hotel/price-template/create', data })
}

// 更新价格模板
export function updatePriceTemplate(data: PriceTemplateVO) {
  return request.put({ url: '/hotel/price-template/update', data })
}

// 删除价格模板
export function deletePriceTemplate(id: string | number) {
  return request.delete({ url: '/hotel/price-template/delete?id=' + id })
}

// 应用价格模板
export function apply(id: string | number) {
  return request.post({ url: '/hotel/price-template/apply?id=' + id })
}
